export default __webpack_public_path__ + "static/media/like.ed2b44f8.svg";